import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

export const firebaseConfig = {
  apiKey: 'AIzaSyC59NZD1Vyg_wYRRXTmWYAP9C491VT_mRU',
  authDomain: 'socialnetworkforfriends.firebaseapp.com',
  projectId: 'socialnetworkforfriends',
  storageBucket: 'gs://socialnetworkforfriends.appspot.com',
  messagingSenderId: '506098669703',
  appId: '1:506098669703:web:d35ad68ae796b3b95a4022',
  measurementId: 'G-7DMPBESRGR',
  /* apiKey: 'AIzaSyAo_EaBye0lUG6miUfYObK5fCP3arHKQGk',
  authDomain: 'streaming-website-8198f.firebaseapp.com',
  projectId: 'streaming-website-8198f',
  storageBucket: 'streaming-website-8198f.appspot.com',
  messagingSenderId: '228930366638',
  appId: '1:228930366638:web:bfbefa95ace3fff3c5913f',
  measurementId: 'G-7DMPBESRGR',
  databaseURL: 'streaming-website-8198f.firebaseio.com', */
};
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore();
const storage = getStorage(app);
